import React, {useEffect, useState, useRef} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';

import InputGroup from 'react-bootstrap/InputGroup';

import Spinner from 'react-bootstrap/Spinner';

import Modal from 'react-bootstrap/Modal';

import Image from 'react-bootstrap/Image';
import logo from '../BronzeTagIcon48.png';

import {
    Link,
  } from "react-router-dom";

import { useNavigate } from "react-router-dom";

import '../App.css';

const AccountRegistration = ({}) => {

    const formRef = useRef(null);

    const navigate = useNavigate();

    const [validated, setValidated] = useState(false);
    
    let [countries, setCountries] = useState([]);
    let [states, setStates] = useState([]);
    let [countryId, setCountryId] = useState(null);
    let [stateId, setStateId] = useState(null);
    let [companyCode, setCompanyCode] = useState('');

    let [firstName, setFirstName] = useState('');
    let [lastName, setLastName] = useState('');
    let [email, setEmail] = useState('');
    let [phoneNumber, setPhoneNumber] = useState('');
    let [password, setPassword] = useState('');
    let [confirmPassword, setConfirmPassword] = useState('');
    let [companyName, setCompanyName] = useState('');
    let [address, setAddress] = useState('');
    let [address2, setAddress2] = useState('');
    let [city, setCity] = useState('');
    let [zipCode, setZipCode] = useState('');
    let [loading, setLoading] = useState('');

    let [emailAlreadyExists, setEmailAlreadyExists] = useState(false);
    let [emailAddressPendingConfirmation, setEmailAddressPendingConfirmation] = useState(false);
    let [companyCodeExists, setCompanyCodeExists] = useState(false);
    let [companyCodeReserved, setCompanyCodeReserved] = useState(false);
    let [registrationFailed, setRegistrationFailed] = useState(false);

    let [registrationComplete, setRegistrationComplete] = useState(false);

    let [licenseTypes, setLicenseTypes] = useState([]);

    useEffect(() => {
        async function fetchCountries() {
            
            const baseUrl = process.env.REACT_APP_API_URL;
            // const url = `${baseUrl}/restServices/commonConfigurationController/getAllCountries`;
            const url = `${baseUrl}/api/getAllCountries`;

            fetch(
               url,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                }
            )
            .then(res => res.json())
            .then(response => {
                console.log(response);
                setCountries(response.data);
                setCountryId(response.data[0].countryId);

                fetchStates(response.data[0].countryId);
            })
            .catch(error => console.log(error));
        }



        async function fetchStates(countryId) {
            
            const baseUrl = process.env.REACT_APP_API_URL;
            // const url = `${baseUrl}/restServices/commonConfigurationController/getStates/${countryId}`;
            const url = `${baseUrl}/api/getStates?countryId=${countryId}`;

            fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                }
            )
            .then(res => res.json())
            .then(response => {
                console.log(response);
                setStates(response.data);
                
            })
            .catch(error => console.log(error));
        }

        async function fetchLicenseTypes() {
            
            const baseUrl = process.env.REACT_APP_API_URL;

            fetch(
                `${baseUrl}/restServices/commonConfigurationController/getBronzeTagLicenseTypes`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                }
            )
            .then(res => res.json())
            .then(response => {
                console.log(response);
                setLicenseTypes(response.data);
                
            })
            .catch(error => console.log(error));
        }
          
    
        fetchLicenseTypes();
        fetchCountries();
        
    }, []); 

    const clear = () => {
        setCompanyName('');
        setStateId(null);
        setCountryId(null);
        setZipCode('');
        setCompanyCode('');
        setFirstName('');
        setLastName('');
        setEmail('');
        setPassword('');
        setPhoneNumber('');
    }

    const renderStates = () => {
        return states.map(state => (
            <option value={state.stateId} key={state.stateId}>{`${state.shortName} - ${state.stateName}`}</option>    
        ))
    }

    const renderCountries = () => {
        return countries.map(country => (
            <option value={country.countryId} key={country.countryId}>{country.countryName}</option>    
        ))
    }

    const onStateChange = async (event) => {
        console.log("state selected:", event.target.value);
        setStateId(event.target.value);
    }

    const onCountryChange = (event) => {
        console.log("country selected:", event.target.value);
        setCountryId(event.target.value);
    }

    const onCompanyCodeChange = (event) => {
        console.log("company code", event.target.value);
        setCompanyCode(event.target.value);
    }

    const onSubmitClick = (event) => {

        setEmailAlreadyExists(false);
        setEmailAddressPendingConfirmation(false);
        setCompanyCodeExists(false);
        setCompanyCodeReserved(false);
        setRegistrationFailed(false);
        
        if (formRef.current.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setValidated(true);
        setLoading(true);

        const baseUrl = process.env.REACT_APP_API_URL;

        let request = {
            "companyName": companyName,
            "companyAddress": address,
            "companyAddress2": address2,
            "companyCity": city,
            "stateId": stateId,
            "countryId": countryId,
            "zipCode": zipCode,
            "companyCode": companyCode,
            "firstName": firstName,
            "lastName": lastName,
            "email": email,
            "password": password,
            "phoneNumber": phoneNumber 
        };

        fetch(
            `${baseUrl}/api/registerNewAccount`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            }
        )
        .then(async response => {
            console.log(response);
            setLoading(false);
            if (response.status === 200) {
                let res = await response.json();
                if (res.data === 'EMAIL_ALREADY_USED') {
                    //alert("The email address is already in use");
                    setEmailAlreadyExists(true);
                } else if (res.data === 'EMAIL_PENDING_CONFIRMATION') {
                    //alert("This email address has already been registered and is pending confirmation");
                    setEmailAddressPendingConfirmation(true);
                } else if (res.data === 'COMPANYCODE_ALREADY_USED') {
                    //alert("Vanity URL is already in use. Please choose a different one");
                    setCompanyCodeExists(true);
                } else if (res.data === 'COMPANYCODE_IS_RESERVED') {
                    setCompanyCodeReserved(true);
                } else {
                    setRegistrationComplete(true);
                }
            } else {
                //alert("Registration failed")
                setRegistrationFailed(true);
            }
        })
        .catch(error => {console.log(error); setLoading(false)});
    }

  return (
    <>
    <div className="container">

        <h3 className="mt-4 mb-3">New Account Registration

        </h3>

        <ol className="breadcrumb">
            <li className="breadcrumb-item">
                <Link to="/">Home</Link>
                {/* <a href="index.html">Home</a> */}
            </li>
            <li className="breadcrumb-item active">Register</li>
        </ol>
    </div>
    <div style={{width: '100%', padding: 24, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
        <div style={{maxWidth: 600}}>
            
    
    
    {loading && <Modal
                show={true}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Body>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <span style={{fontSize: 14}}>Creating Account. Please wait ...</span>
                        <Spinner animation="border" role="status">
                            
                        </Spinner>
                    </div>
                </Modal.Body>
            </Modal>
            }

    {registrationComplete && <Modal
                show={true}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Body>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Form.Text>Registration Complete</Form.Text>
                        <Image src={logo}/>
                        <div>Thank you! Please check your email and click the confirmation link</div>
                        <div style={{fontSize:11}}>To complete the registration process, please click the link in the email we just sent you. </div>
                        <div style={{fontSize:11}}>If it doesn’t show up in a few minutes, check your spam folder.</div>
                        <div style={{fontSize:11, marginTop: 8}}>If you are using Google Apps or Gmail, also check your Promotions tab.</div>

                        <Button variant="primary" onClick={() => {setRegistrationComplete(false); clear(); navigate("/");}}>
                            Ok
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            }
    <Form ref={formRef} noValidate validated={validated}>
            {emailAddressPendingConfirmation &&
                <Container> 
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                The email address you entered has already been registered and pending confirmation.
                        </Form.Text>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                Please check your Inbox or possibly your Spam folder for a confirmation email from us.
                        </Form.Text>
                    </Col>
                </Row>
                </Container>
            }

            {emailAlreadyExists &&
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                The email address you entered has already been registered.
                        </Form.Text>
                    </Col>
                </Row>
            }

            {companyCodeExists &&
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                The account code you entered is already being used by another account. Please choose a different one.
                        </Form.Text>
                    </Col>
                </Row>
            }

            {companyCodeReserved &&
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                The account code you entered is reserved. Please choose a different one.
                        </Form.Text>
                    </Col>
                </Row>
            }

            {registrationFailed &&
                <Row>
                    <Col>
                        <Form.Text style={{fontSize: 12, color: '#dc3545'}}>
                                Oops! Something has gone bad on our end. Please try again at a later time.
                        </Form.Text>
                    </Col>
                </Row>
            }
            
            
        
            <Row>
                <Col sm={12} md={6} lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicFirstName">
                        <Form.Label className="Form-label">First Name</Form.Label>
                        <Form.Control required type="text" placeholder="First Name"  onChange={(event) => {setFirstName(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your first name.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicLastName">
                        <Form.Label className="Form-label">Last Name</Form.Label>
                        <Form.Control required type="text" placeholder="Last Name"  onChange={(event) => {setLastName(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your last name.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} lg={6} >
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="Form-label">Email address</Form.Label>
                        <Form.Control isInvalid={emailAlreadyExists || emailAddressPendingConfirmation} required type="email" placeholder="Enter email"  onChange={(event) => {setEmail(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            {emailAddressPendingConfirmation ? 'Email address pending confirmation': emailAlreadyExists ? 'Email address already registered' : 'Please enter your email address.'}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicPhoneNumber">
                        <Form.Label className="Form-label">Phone Number</Form.Label>
                        <Form.Control required type="tel" placeholder="Enter your phone number"  onChange={(event) => {setPhoneNumber(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your phone number.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Text className="Form-label text-muted">
                        We'll never share your email or phone number with anyone else.
                    </Form.Text>
                </Col>
            </Row>
            <Row>
                <Col sm={6} md={6}>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label className="Form-label">Password</Form.Label>
                        <Form.Control required isInvalid={password.length > 0 && password.length < 8} type="password" placeholder="Password"  onChange={(event) => {setPassword(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter a password 8 or more characters long.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={6} md={6}>
                    <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
                        <Form.Label className="Form-label">Confirm Password</Form.Label>
                        <Form.Control required type="password" isInvalid={confirmPassword.length > 0 && confirmPassword !== password} placeholder="Confirm Password" onChange={(event) => {setConfirmPassword(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please confirm your password.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Text className="text-muted">
                        Business Information.
                        </Form.Text>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col sm={12}>
                    <Form.Label className="Form-label" htmlFor="basic-url">Your account code</Form.Label>
                    <Form.Text style={{fontSize: 12}}>
                        Please select a unique and user friendly account code. This code will be used by your customers to view your online store.
                    </Form.Text>
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon3">
                            https://
                        </InputGroup.Text>
                        <Form.Control isInvalid={companyCodeExists} required onChange={onCompanyCodeChange} id="basic-url" aria-describedby="basic-addon3" />
                        <InputGroup.Text id="basic-addon3">
                            .bronzetag.com
                        </InputGroup.Text>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            {companyCodeExists ? 'Account code already registered' : 'Please choose an account code.'}
                        </Form.Control.Feedback>
                    </InputGroup>
                </Col>
            </Row>
      
            <Row>
                <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formBasicBusinessName">
                        <Form.Label className="Form-label">Business Name</Form.Label>
                        <Form.Control required type="text" placeholder="Enter your business/company name" onChange={(event) => {setCompanyName(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your business name.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formBasicBusinessAddress">
                        <Form.Label className="Form-label">Address</Form.Label>
                        <Form.Control required type="text" placeholder="Enter your business/company address" onChange={(event) => {setAddress(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your business address.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formBasicBusinessAddress2">
                        <Form.Label className="Form-label">Address Line 2</Form.Label>
                        <Form.Control type="text" placeholder="Address Line 2" onChange={(event) => {setAddress2(event.target.value)}}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formBasicBusinessZipCode">
                        <Form.Label className="Form-label">Postal Code (Zip Code)</Form.Label>
                        <Form.Control required type="text" placeholder="Postal Code" onChange={(event) => {setZipCode(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your business postal code.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formBasicBusinessCity">
                        <Form.Label className="Form-label">City</Form.Label>
                        <Form.Control required type="text" placeholder="Enter your business/company city" onChange={(event) => {setCity(event.target.value)}}/>
                        <Form.Control.Feedback style={{fontSize: 10}} type="invalid">
                            Please enter your business city.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="formBasicBusinessCity">
                        <Form.Label className="Form-label">State</Form.Label>
                        <Form.Select aria-label="State" onChange={(value) => onStateChange(value)}>
                            {renderStates()}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="formBasicBusinessCountry">
                        <Form.Label className="Form-label">Country</Form.Label>
                        <Form.Select aria-label="State" onChange={(value) => onCountryChange(value)}>
                            {renderCountries()}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
      
            <Button variant="primary" onClick={onSubmitClick}>
                Create Account
            </Button>
    </Form>
        </div>
    </div>
    </>
  );
}

export default AccountRegistration;